export default __webpack_public_path__ + "static/media/LAS.9862e174.svg";